export const toDataUrl = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
  })
}

export const createWhiteImageDataUrl = () => {
  const canvas = document.createElement('canvas')
  canvas.width = 200
  canvas.height = 200
  const dataURL = canvas.toDataURL('image/png')
  return dataURL
}

// data URL（"data:image/png;base64,..."）を Blob にする。本人確認書類の削除で送る白画像（canvas の data URL）を
// application/octet-stream の本文で送るのに使う
export const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(',')
  const type = header.split(':')[1].split(';')[0]
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new Blob([bytes], { type })
}
